import React, { useState } from "react";
import { T } from "../theme";
import { Btn, Card, SectionTitle, TapeIcon } from "../ui";

export default function ProductDetailScreen({ product, onAddToCart, onBack }) {
  const availableVariants = product.variants.filter((v) => v.availableForSale);
  const [variantId, setVariantId] = useState((availableVariants[0] || product.variants[0])?.id);
  const [adding, setAdding] = useState(false);
  const [added, setAdded] = useState(false);
  const [error, setError] = useState("");

  const variant = product.variants.find((v) => v.id === variantId);

  const addToCart = async () => {
    setError("");
    setAdding(true);
    setAdded(false);
    try {
      await onAddToCart(variantId, 1);
      setAdded(true);
    } catch (e) {
      setError(e.message || "Could not add to cart.");
    } finally {
      setAdding(false);
    }
  };

  return (
    <div>
      <Card style={{ textAlign: "center", padding: "20px 16px" }}>
        {product.imageUrl ? (
          <img src={product.imageUrl} alt={product.imageAlt} style={{ width: "100%", maxHeight: 220, objectFit: "cover", borderRadius: 8 }} />
        ) : (
          <TapeIcon size={80} />
        )}
        <div style={{ fontSize: 20, fontWeight: "bold", color: T.text, marginTop: 12 }}>{product.title}</div>
        <div style={{ fontSize: 18, fontWeight: "bold", color: T.value, marginTop: 4 }}>
          {variant ? `$${Number(variant.price).toFixed(2)}` : `$${Number(product.minPrice).toFixed(2)}`}
        </div>
      </Card>

      {product.description && (
        <>
          <SectionTitle>Description</SectionTitle>
          <Card><div style={{ fontSize: 13, color: T.muted, lineHeight: 1.7 }}>{product.description}</div></Card>
        </>
      )}

      {product.variants.length > 1 && (
        <>
          <SectionTitle>Options</SectionTitle>
          <div style={{ marginBottom: 10 }}>
            <label style={{ fontSize: 9, color: T.muted, letterSpacing: "0.18em", textTransform: "uppercase", display: "block", marginBottom: 3 }}>Choose an Option</label>
            <select
              value={variantId}
              onChange={(e) => setVariantId(e.target.value)}
              style={{ width: "100%", background: T.inputBg, border: `1px solid ${T.border}`, borderRadius: 6, color: T.text, padding: "9px 11px", fontSize: 13, fontFamily: T.font, outline: "none", boxSizing: "border-box" }}
            >
              {product.variants.map((v) => (
                <option key={v.id} value={v.id}>{v.availableForSale ? v.title : `${v.title} (Sold out)`}</option>
              ))}
            </select>
          </div>
        </>
      )}

      {error && <div style={{ color: "#C0392B", fontSize: 12, marginBottom: 10 }}>{error}</div>}
      {added && <div style={{ color: T.green, fontSize: 12, marginBottom: 10 }}>Added to cart.</div>}

      <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
        <Btn variant="outline" onClick={onBack} style={{ flex: 1 }}>← Back</Btn>
        <Btn disabled={adding || !variant?.availableForSale} onClick={addToCart} style={{ flex: 2 }}>
          {adding ? "Adding…" : variant?.availableForSale ? "Add to Cart" : "Sold Out"}
        </Btn>
      </div>
      <div style={{ height: 20 }} />
    </div>
  );
}
